import React from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputField from "../../../form/InputField";
import SubmitButton from "../../../form/SubmitButton";
import { useUpdateResource } from "../../../../hooks/useUpdateResource";
import LoadingButton from "../../../form/LoadingButton";

type Language = {
  languageCode: string;
  name: string;
};

type FormValues = {
  productId: number;
  languages: Language[];
};

interface UpdateSpecialChangeFormProps {
  initialValues?: FormValues; // pre-fill values
  id:number,
  onSubmitSuccess?: () => void; // callback after success
  storeId?:number
}

const UpdateSpecialChangeForm: React.FC<UpdateSpecialChangeFormProps> = ({
  initialValues,
  onSubmitSuccess,
  id,
  storeId
}) => {
  const { t } = useTranslation();
  

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: initialValues ,
  });

  const {loading,updateResource} = useUpdateResource();

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
        const endPoint = storeId ? `product-instruction/${id}?storeId=${storeId}` : `product-instruction/${id}`
        await  updateResource(endPoint, data, storeId?"admin" : "store",{
            method: "PUT",
            successMessage: t("update_success"),
            invalidateQueries:["product-detail"],
          });
        if (onSubmitSuccess) onSubmitSuccess();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      {/* Name EN */}
      <div>
        <InputField
          placeholder={t("name_en")}
          register={register("languages.0.name", {
            required: t("required_field") as string,
          })}
          error={errors?.languages?.[0]?.name}
        />
        <input
          type="hidden"
          {...register("languages.0.languageCode")}
          value="en"
        />
      </div>

      {/* Name AR */}
      <div>
        <InputField
          placeholder={t("name_ar")}
          register={register("languages.1.name", {
            required: t("required_field") as string,
          })}
          error={errors?.languages?.[1]?.name}
        />
        <input
          type="hidden"
          {...register("languages.1.languageCode")}
          value="ar"
        />
      </div>
      {
        loading
        ?
        <LoadingButton/>
        :
        <SubmitButton label={t("update")} />
      }
    </form>
  );
};

export default UpdateSpecialChangeForm;
